import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import "./App.css";
import Blog from "./components/Blogsection/Blog";
import Header from "./components/Header/Header";
import Singlepost from "./components/Singlepost/Singlepost";
import Footer from "./components/Footer/Footer";
import Profile from "./components/Profile/Profile";
import ParticleBackground from "./components/Particles/ParticleBackground";
import Login from "./components/Auth/Login";

import ForgotPassEmail from "./components/Auth/ForgotPasswordEmail";
import ResetPass from "./components/Auth/ResetPassword";
import Contact from "./components/Contact/Contact";
import About from "./components/About/About";
import { authFetch, clearAuthToken, withAuth } from "./helper/auth";

const apiUrl = process.env.REACT_APP_SERVER_URL || "https://hkserver.vercel.app";

const App = () => {
  const location = useLocation();
  const loginValue = localStorage.getItem("isLogin");
  const loginStatus = loginValue === "yes" ? true : false;
  const [isLogin, setIsLogin] = useState(loginStatus);
  const [posts, setPosts] = useState([]);
  const [postCategory, setPostCategory] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [isMessage, setIsMesssage] = useState(false);
  const [message, setMessage] = useState("");

  const [pages, setPages] = useState({
    totalItem: 0,
    totalPage: 0,
    currentPage: 1,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const clearLoginState = () => {
    clearAuthToken();
    localStorage.removeItem("isLogin");
    localStorage.removeItem("option");
    localStorage.removeItem("optionValue");
    localStorage.removeItem("activeCat");
    localStorage.removeItem("postStatus");
    setIsLogin(false);
  };

  const categoryHandler = () => {
    setSearchData("");
    setCurrentPage(1);
  };

  const searchDataHandler = (value) => {
    setSearchData(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    const url = apiUrl + "/auth/verifytoken";

    const authVerify = () => {
      fetch(
        url,
        withAuth({
          method: "post",
        })
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("auth failed");
          }

          return response.json();
        })
        .then((data) => {
          setSearchData("");
          if (data.message === "valid auth") {
            setIsLogin(true);
            localStorage.setItem("isLogin", "yes");
          } else {
            setIsLogin(false);
            localStorage.removeItem("isLogin");
          }
        })
        .catch((err) => {
          clearLoginState();
          console.log(err);
        });
    };
    try {
      const getLocalData = localStorage.getItem("isLogin");
      if (getLocalData) {
        authVerify();
      }
    } catch (err) {
      console.log("localstorage error");
    }
  }, []);

  const logoutHandler = (type = "") => {
    const completeLogout = () => {
      clearLoginState();
      navigate("/");
    };

    if (type === "session" || type === "cookie-issue") {
      completeLogout();
    } else {
      const url = apiUrl + "/auth/logout";

      authFetch(url, {
        method: "POST",
      })
        .then((response) => {
          completeLogout();
        })
        .catch((err) => {
          completeLogout();
          console.log(err);
        });
    }

    if (type === "session") {
      setIsMesssage(true);
      setMessage("Your login session has expired.");
    }
    if (type === "cookie-issue") {
      setIsMesssage(true);
      setMessage(
        "Cookies are not enabled in your browser. Please enable them to access your profile."
      );
    }
  };

  const loginHandler = (value) => {
    setIsLogin(value);
  };

  useEffect(() => {
    const url = apiUrl + "/profile/getcategory";
    fetch(
      url,
      withAuth({
        method: "GET",
      })
    )
      .then((response) => {
        if (response.status === 401) {
          return { postCategory: [] };
        }

        if (!response.ok) {
          throw new Error("server error");
        }

        return response.json();
      })
      .then((data) => {
        setPostCategory(data.postCategory);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    setLoader(true);
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const queryParams = new URLSearchParams(location.search);
    let cat = queryParams.get("catId");
    if (!cat) {
      cat = "All";
    }

    const url =
      apiUrl +
      "/public/getpost?page=" +
      currentPage +
      "&catId=" +
      cat +
      "&search=" +
      searchData +
      "&timeZone=" +
      userTimezone;

    fetch(
      url,
      withAuth({
        method: "GET",
      })
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error("server error");
          throw error;
        }
        return response.json();
      })
      .then((data) => {
        setLoader(false);
        setPages({
          totalItem: data.totalItem,
          totalPage: data.totalPage,
          currentPage: Number(data.currentPage),
        });
        setPosts(data.posts);
      })
      .catch((err) => {
        console.log(err);
        setPosts([]);
        setLoader(false);
      });
  }, [currentPage, searchData, location.search]);

  const currentPageHandler = (value) => {
    setCurrentPage(value);
  };

  const crossHandler = (value) => {
    setIsMesssage(value);
  };

  useEffect(() => {
    if (location.pathname !== "/") {
      return;
    }

    const queryParams = new URLSearchParams(location.search);
    const resetToken = queryParams.get("resetToken");

    if (!resetToken) {
      return;
    }

    navigate(`/resetpassword?token=${encodeURIComponent(resetToken)}`, {
      replace: true,
    });
  }, [location.pathname, location.search, navigate]);

  return (
    <Fragment>
      <ParticleBackground />
      <Header
        isLogin={isLogin}
        logout={logoutHandler}
        crossHandler={crossHandler}
        message={message}
        isMessage={isMessage}
      />
      <Routes>
        <Route
          path="/login"
          element={
            !isLogin ? (
              <Login isLogin={loginHandler} logout={logoutHandler} />
            ) : (
              <Blog
                posts={posts}
                pages={pages}
                currentPageHandler={currentPageHandler}
                isLoader={isLoader}
                postCategory={postCategory}
                categoryHandler={categoryHandler}
                searchDataHandler={searchDataHandler}
              />
            )
          }
        />
        {/*<Route
          path="/signup"
          element={
            !isLogin ? (
              <Signup />
            ) : (
              <Blog
                posts={posts}
                pages={pages}
                currentPageHandler={currentPageHandler}
                isLoader={isLoader}
                postCategory={postCategory}
                categoryHandler={categoryHandler}
                searchDataHandler={searchDataHandler}
              />
            )
          }
        />*/}

        <Route
          path="/forgotpassword"
          element={
            !isLogin ? (
              <ForgotPassEmail />
            ) : (
              <Blog
                posts={posts}
                pages={pages}
                currentPageHandler={currentPageHandler}
                isLoader={isLoader}
                postCategory={postCategory}
                categoryHandler={categoryHandler}
                searchDataHandler={searchDataHandler}
              />
            )
          }
        />
        <Route
          path="/"
          element={
            <Blog
              posts={posts}
              pages={pages}
              currentPageHandler={currentPageHandler}
              isLoader={isLoader}
              postCategory={postCategory}
              categoryHandler={categoryHandler}
              searchDataHandler={searchDataHandler}
            />
          }
        />
        <Route path="/post" element={<Singlepost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />

        <Route
          path="/profile"
          element={
            isLogin ? (
              <Profile postCategory={postCategory} logout={logoutHandler} />
            ) : (
              <Blog
                posts={posts}
                pages={pages}
                currentPageHandler={currentPageHandler}
                isLoader={isLoader}
                postCategory={postCategory}
                categoryHandler={categoryHandler}
                searchDataHandler={searchDataHandler}
              />
            )
          }
        />
        <Route
          path="/resetpassword"
          element={
            !isLogin ? (
              <ResetPass />
            ) : (
              <Blog
                posts={posts}
                pages={pages}
                currentPageHandler={currentPageHandler}
                isLoader={isLoader}
                postCategory={postCategory}
                categoryHandler={categoryHandler}
                searchDataHandler={searchDataHandler}
              />
            )
          }
        />
      </Routes>
      <Footer />
    </Fragment>
  );
};

export default App;
